import './PrivacyPolicy.css';
import React, { useState, useEffect, useRef, Component } from 'react';

//I have used the following generator:
//https://www.freeprivacypolicy.com/live/0ebf5372-447c-457a-8a94-5415f080fba1

function PrivacyPolicy() {
  useEffect(() => {}, []);

  var someLink = (
    <a href="http://localhost:3000/policy-cookie">Cookies Policy</a>
  );
  return (
    <div className="privacy-policy-container">
      <h1 className="big-header">Twist Privacy Policy</h1>
      <p>Last updated: April 26, 2021</p>
      <p>
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law protects
        You.
      </p>
      <p>
        We use Your Personal data to provide and improve the Service. By using
        the Service, You agree to the collection and use of information in
        accordance with this Privacy Policy. This Privacy Policy has been
        created with the help of the Privacy Policy Generator.
      </p>
      <h2 className="medium-header">Interpretation and Definitions</h2>
      <h3>Interpretation</h3>
      <p>
        The words of which the initial letter is capitalized have meanings
        defined under the following conditions. The following definitions shall
        have the same meaning regardless of whether they appear in singular or
        in plural.
      </p>
      <p>For the purposes of this Privacy Policy:</p>
      <ul>
        <li>
          Account means a unique account created for You to access our Service
          or parts of our Service.
        </li>
        <li>
          Affiliate means an entity that controls, is controlled by or is under
          common control with a party, where "control" means ownership of 50% or
          more of the shares, equity interest or other securities entitled to
          vote for election of directors or other managing authority.
        </li>
        <li>
          Application means the software program provided by the Company
          downloaded by You on any electronic device, named Twist
        </li>
        <li>
          Company (referred to as either "the Company", "We", "Us" or "Our" in
          this Agreement) refers to Twist.
        </li>
        <li>Country refers to: Quebec, Canada</li>
        <li>
          Device means any device that can access the Service such as a
          computer, a cellphone or a digital tablet.
        </li>
        <li>
          Personal Data is any information that relates to an identified or
          identifiable individual.
        </li>
        <li>Service refers to the Application.</li>
        <li>
          Service Provider means any natural or legal person who processes the
          data on behalf of the Company. It refers to third-party companies or
          individuals employed by the Company to facilitate the Service, to
          provide the Service on behalf of the Company, to perform services
          related to the Service or to assist the Company in analyzing how the
          Service is used.
        </li>
        <li>
          Third-party Social Media Service refers to any website or any social
          network website through which a User can log in or create an account
          to use the Service.
        </li>
        <li>
          Usage Data refers to data collected automatically, either generated by
          the use of the Service or from the Service infrastructure itself (for
          example, the duration of a page visit).
        </li>
        <li>
          You means the individual accessing or using the Service, or the
          company, or other legal entity on behalf of which such individual is
          accessing or using the Service, as applicable.
        </li>
      </ul>
      <h1>Collecting and Using Your Personal Data</h1>
      <h2>Types of Data Collected:</h2>
      <h3>Personal Data</h3>
      <p>
        While using Our Service, We may ask You to provide Us with certain
        personally identifiable information that can be used to contact or
        identify You. Personally identifiable information may include, but is
        not limited to:
      </p>
      <ul>
        <li>Advertising Identifier(IDFA)</li>
        <li> Usage Data</li>
      </ul>
      <h3>Advertising Identifier</h3>
      <p>
        The Advertising Identifier (IDFA) is a unique ID for each iOS device and
        is the only way to offer targeted ads. Users can choose to limit ad
        targeting on their iOS device. The Twisted app indirectly uses the IDFA
        through the Facebook SDK. Advertising Identifier(IDFA) is used to:
      </p>
      <ul>
        <li>Serve advertisements within the app</li>
        <li>
          Attribute the app installation to a previously served advertisement
        </li>
        <li>
          Attribute an action taken within the app to a previously served
          advertisement
        </li>
      </ul>
      <h3>Usage Data</h3>
      <p>
        Usage Data is collected automatically when using the Service.It may
        include information such as the pages of our Service that You visit, the
        time and date of Your visit, the time spent on those pages, unique
        device identifiers and other diagnostic data.
      </p>
      <p>
        When You access the Service by or through a mobile device, We may
        collect certain information automatically, including, but not limited
        to, the type of mobile device You use, Your mobile device unique ID,
        Your mobile operating system, unique device identifiers and other
        diagnostic data.
      </p>
      <h2>Use of Usage Data</h2>
      <p>The Company may use Usage Data for the following purposes:</p>
      <ul>
        <li>
          To provide and maintain our Service, including to monitor the usage of
          our Service.
        </li>
        <li>
          For the performance of a contract: the development, compliance and
          undertaking of the purchase contract for the products, items or
          services You have purchased or of any other contract with Us through
          the Service.
        </li>
        <li>
          For other purposes: We may use Your information for other purposes,
          such as data analysis, identifying usage trends, determining the
          effectiveness of our promotional campaigns and to evaluate and improve
          our Service, products, services, marketing and your experience.
        </li>
      </ul>
      <p>We may share Your personal information in the following situations:</p>
      <ul>
        <li>
          With Service Providers: We may share Your personal information,
          especially usage data, with Service Providers to monitor and analyze
          the use of our Service.
        </li>
        <li>
          For business transfers: We may share or transfer Your personal
          information in connection with, or during negotiations of, any merger,
          sale of Company assets, financing, or acquisition of all or a portion
          of Our business to another company.
        </li>
        <li>
          With Affiliates: We may share Your information with Our affiliates, in
          which case we will require those affiliates to honor this Privacy
          Policy. Affiliates include Our parent company and any other
          subsidiaries, joint venture partners or other companies that We
          control or that are under common control with Us.
        </li>
      </ul>
      <h2>Retention of Your Personal Data</h2>
      <p>
        The Company will retain Your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will
        retain and use Your Personal Data to the extent necessary to comply with
        our legal obligations (for example, if we are required to retain your
        data to comply with applicable laws), resolve disputes, and enforce our
        legal agreements and policies.
      </p>
      <p>
        The Company will also retain Usage Data for internal analysis purposes.
        Usage Data is generally retained for a shorter period of time, except
        when this data is used to strengthen the security or to improve the
        functionality of Our Service, or We are legally obligated to retain this
        data for longer time periods.
      </p>
      <h2>Disclosure of Your Personal Data</h2>
      <h3>Third Parties</h3>
      <p>
        We may share your information with third parties to improve the app,
        provide you a better user experience and serve advertisements. The
        information we share could be collected directly by us, or by Software
        Development Kits that are integrated into the service. Such third
        parties include:
      </p>
      <ul>
        <li>Facebook</li>
      </ul>
      <p>
        Third parties have their own way of handling and processing data,
        therefore we encourage our users to learn more about the privacy
        policies of the companies posted above.
      </p>
      <h3>Business Transactions</h3>
      <p>
        If the Company is involved in a merger, acquisition or asset sale, Your
        Personal Data may be transferred. We will provide notice before Your
        Personal Data is transferred and becomes subject to a different Privacy
        Policy.
      </p>
      <h2>Security of Your Personal Data</h2>
      <p>
        The security of Your Personal Data is important to Us, but remember that
        no method of transmission over the Internet, or method of electronic
        storage is 100% secure. While We strive to use commercially acceptable
        means to protect Your Personal Data, We cannot guarantee its absolute
        security.
      </p>
      <h2>Children's Privacy</h2>
      <p>
        Our Service does not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from anyone under
        the age of 13. If You are a parent or guardian and You are aware that
        Your child has provided Us with Personal Data, please contact Us. If We
        become aware that We have collected Personal Data from anyone under the
        age of 12 without verification of parental consent, We take steps to
        remove that information from Our servers.
      </p>
      <p>
        If We need to rely on consent as a legal basis for processing Your
        information and Your country requires consent from a parent, We may
        require Your parent's consent before We collect and use that
        information.
      </p>
      <h2>Changes to this Privacy Policy</h2>
      <p>
        We may update Our Privacy Policy from time to time. We will notify You
        of any changes by posting the new Privacy Policy on this page. We will
        update the "Last updated" date at the top of this Privacy Policy.
      </p>
      <p>
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are
        posted on this page.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, You can contact us
        at: twistedapp@hotmail.com
      </p>
    </div>
  );
}

export default PrivacyPolicy;
